import React,{useState,useEffect} from 'react';
import {Box,LinearProgress,//IconButton,Typography
    IconButton,Tooltip,FormControl,InputLabel,Select, Button,
    MenuItem,TextField,FormControlLabel,Checkbox,
    Typography} from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import SearchIcon from '@material-ui/icons/Search';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import TablaEstruct from './TablaEstructura';
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import ModalNvoEdit from './ModalNvo';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

export default function CatalogoApoyo(){
 
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ;  
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0;      
    const Dispvo =localStorage.getItem('Dispvo') ;    
 
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs'      
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);     
    
    const [fSelect, setFSelect] = useState({inicio:new Date(),final:new Date()});
    const [fSelect2, setFSelect2] = useState({inicio:new Date(),final:new Date()});
 
    const [espera,setEspera]=useState(false);
 
    const [afiliado,setAfiliado]=useState({muni:0, secc:0,fecha:true,cadena:""});
    const [filtro,setFiltro]=useState({distrito:0, otb:0, barrio:0});
    const [listApoyo,setListApoyo]=useState([])
 
    const [listPart, setListPart]=useState([]);    
    const [modalNvo, setModalNvo] = useState(false);    
 
    const{muni, secc, fecha, cadena}=afiliado
    const{distrito, otb, barrio}=filtro
    const {inicio,final}=fSelect  
    //const drawerWidth = 125;
    useEffect(()=>{             
        const autenticado = authUser();
        if(!autenticado){
            localStorage.clear();
            history.push("/");
            guardarUsuario([])
        }
        else
        {   const usu= localStorage.getItem('UsuarioNom');                 
            if (usuario.length===0) 
            {
                guardarUsuario({Nombre:usu,nivel:nvl});      
                                                     
            }      
            
     
    
            getDatos()
                        
            guardarGenerales({...generales,Titulo:'Catálogo Apoyo'})      
                
        }
        
        return ()=> {
            source.cancel();
        }      
    //la siguiente linea puede generar errores o no en el useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
 
    const funcActualizar=( )=>{       
        getDatos()
        //getLisAvance()         
    }

 

    const getDatos = () => {   
    
        const data = qs.stringify({            
            Usuario:auxId,
            idDispositivo: auxDispV,
        });
        const url = "perfil/v2/ios/apoyo";
        function respuesta(aux) {
            if (aux[0].Id!== -1 && aux[0].Id!== 0&& aux[0].Id!== "0")
            {   setListApoyo(aux)
            }
            else{
                setListApoyo([])
            }
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    };
 
 
    const guardarInicio = auxfecha =>
    {
        setFSelect({...fSelect, inicio : auxfecha })
    };

    const guardarFinal = auxfecha =>
    {
        setFSelect({ ...fSelect, final : auxfecha })
    };
 
 
 
    const Reloj =()=>{
    return<MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>    
        <Box component="span" mt={1} >
        <Box  ml={1}  component="span" width={1/4}>                                                
            <DatePicker
                disableFuture format="dd/MM/yyyy"
                views={["year", "month", "date"]}
                label="Fecha Inicial" size="small"
                minDate="2021-12-31" maxDate={new Date()}
                value={inicio} onChange={guardarInicio}      
                style={{width:6.5+'rem'}} cancelLabel={"Cancelar"}                  
                okLabel="Seleccionar" disabled={!fecha}
            />
        </Box>    
        <Box ml={1}  component="span" width="25%">
            <DatePicker
                disableFuture id="final" disabled={!fecha}
                format="dd/MM/yyyy" label="Fecha Final"
                views={["year", "month", "date"]}
                minDate={inicio} maxDate={new Date()}
                value={final} name="final" cancelLabel={"Cancelar"}  
                size="small" style={{width:6.5+'rem'}}      
                okLabel="Seleccionar"  onChange={guardarFinal}
                minDateMessage={"La fecha final debe ser menor a Fecha inicial"}
            />
        </Box> 
    </Box>                         
    </MuiPickersUtilsProvider>
    }
    const auxmodNvo = modalNvo ? 
    <ModalNvoEdit modalAbierto={modalNvo} setModalAbierto={setModalNvo} getDatos={funcActualizar}
        titulo="Nuevo Registro"     
        listPart={[]}       
    />:null

    const btnNvo=()=>{
        return(
        <Tooltip title={`Nuevo `}>
          <IconButton aria-label="agregar nuevo" onClick={() => setModalNvo(true)} 
            component="span"  style={{marginTop:".5rem"}}
          >
            <AddCircleOutlineIcon  color='primary' />  
          </IconButton>
        </Tooltip> 
        )
      }

    const contenido=()=>{
        return(
        <Box display={'flex'} flexDirection="column" >
             
            <Box mb={1} display={"flex"} flexDirection={"row"}>    
            {auxmodNvo}             
                <Button onClick={funcActualizar} style={{width:"7rem", marginRight:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color, height:"2.5rem", marginTop:"1rem"}} 
                    size='small' variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
                    Buscar     
                </Button>
                {btnNvo()}
           
             
               
            </Box>      
                
            <Box>
                {espera ?
                <Box width={"40rem"} ml={2} mt={2}><LinearProgress/></Box>
                : <TablaEstruct muni={listApoyo}    fSelect={fSelect2}
                      //listTipo={listTipo}  
                    getDatos={funcActualizar}    
                />}
            </Box>
              
        </Box>)
    }

    return (
    <Box display="flex" flexDirection="row" style={{ marginLeft:'1rem'}} >        
        {listApoyo.length!==0 ? 
            (contenido) 
        :  (<Box pt={1} sx={{width:'100%'}}><LinearProgress/> </Box>)
        }              
    </Box>
    )
}
 